export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export function dateIsGreaterThan(
  prevDate = new Date(),
  nextDate = new Date()
) {
  if (prevDate && nextDate) {
    return prevDate > nextDate;
  }

  return false;
}

export function datesAreGreaterThan(prevDates = [], nextDate = new Date()) {
  if (prevDates && nextDate) {
    return prevDates.every((e) => {
      return e > nextDate;
    });
  }

  return false;
}

export function datesAreMinorThan(prevDates = [], nextDate = new Date()) {
  if (prevDates && nextDate) {
    return prevDates.every((e) => {
      return e < nextDate;
    });
  }
  return false;
}

export const stringToLocaleDateString = (value) => {
  const date = value && new Date(value);
  if (date && date.getMilliseconds() == 0)
    return '-';
  if (date)
    return date.toLocaleDateString("it-IT");
  return '-';
}

export const isEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
